/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
} from "reactstrap";
import queryString from "query-string";

import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";
import "moment-timezone";
import ReactLoading from "react-loading";
import { getUser } from "./../../authetication/adal-config";
import {
  postAcao,
  createTab,
  updateTab,
  deleteTab,
  publishTab,
  createCard,
  updateCard,
  deleteCard,
  enableLocalFileTab,
  updateTabOrder,
} from "redux/actions/Screening/screeningActions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CadastroCard from "./../../views/modals/cadastrar-card";
import EditarCard from "./../../views/modals/editar-card";
import CadastroAba from "./../../views/modals/cadastrar-aba";
import PublicarAba from "./../../views/modals/publicar-aba";
import CadastrarMenu from "./../../views/modals/cadastrar-menu";
import VerImg from "./../../views/modals/ver-img";

import "moment/locale/pt-br";
import classnames from "classnames";
import useEffectAfterMount from "hooks/useEffectAfterMount";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Fragment } from "react";
import { getVersoes } from "services/blob";
import { isMobile } from "react-device-detect";
// import { Viewer, Worker } from "@react-pdf-viewer/core";
// import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
// import "@react-pdf-viewer/core/lib/styles/index.css";
// import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import Select from "react-select";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../../authetication/authConfig";
import { getGroups } from "../../authetication/adal-config";
import Events from "views/Events";
import LiveTranscriptPage from "views/Transcription";
import LiveTranscriptPage2 from "views/Transcription2";
const _ = require("lodash");

const MySwal = withReactContent(Swal);
moment.locale("pt-br");

const token = process.env.REACT_APP_TOKEN_BLOB;
const URL_PDF = process.env.REACT_APP_URL_PDF;
const URL_GODASH = process.env.REACT_APP_URL_GODASH;

function Frame(props) {
  getUser();
  //getGroups(msalInstance);
  const [openAba, setOpenAba] = useState(false);
  const [openCadastraMenu, setOpenCadastraMenu] = useState(false);
  const [openPublicaAba, setOpenPublicaAba] = useState(false);
  const [card, setCard] = useState();
  const [updateAba, setUpdateAba] = useState(false);
  const [updateCard, setUpdateCard] = useState(false);
  const [openCard, setOpenCard] = useState(false);
  const [openEditCard, setOpenEditCard] = useState(false);
  const [dropdownOpenAba, setDropdownOpenAba] = useState(false);
  const [dropdownOpenCard, setDropdownOpenCard] = useState(false);
  const [openVersion, setOpenVersion] = useState(false);
  const [list, setList] = useState([]);
  const [data, setData] = useState([]);
  const [abaEdit, setAbaEdit] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const hasAcess = props.usuariosAdm?.length > 0;
  const tokenSystem = localStorage.getItem("teste");
  const [enableLocalFile, setEnableLocalFile] = useState(false);
  const [openImg, setOpenImg] = useState(false);
  const event = props.menu.includes("Agenda");
  //const transcript = props.menu.includes("Transcription746");
  //effect

  useEffectAfterMount(() => {
    if (props.publish) props.refresh(false);
  }, [props.publish]);

  useEffectAfterMount(() => {
    if (props.create) props.refresh(false);
  }, [props.create]);

  useEffect(() => {
    if (props.data) {
      console.log("entrou aqui");
      let cards = props.data.map((item) => {
        item.abaAtiva = 1;
        item.values = item.values.map((item) => {
          item.abaAtiva = 1;
          item.urlDefault = item.url;
          item.isUrlDefault = true;
          return item;
        });
        return item;
      });
      setData(cards);
    }
    const menuAtual = JSON.parse(localStorage.getItem("menus"))?.find(
      (item) =>
        // eslint-disable-next-line eqeqeq
        item.area == localStorage.getItem("area") &&
        // eslint-disable-next-line eqeqeq
        item.id == localStorage.getItem("idMenu")
    );
    setEnableLocalFile(menuAtual?.habilita_arquivo_local);
  }, [props.data]);

  // useEffect(() => {
  //   setData([...data]);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [list]);

  const toggle = (tabObject, tab) => {
    if (tabObject.abaAtiva !== tab) {
      tabObject.abaAtiva = tab;
      setData([...data]);
      //setActiveTab(tab);
    }
  };

  const toggleAba = (index) => {
    if (dropdownOpenAba !== index) setDropdownOpenAba(index);
    else setDropdownOpenAba(false);
  };

  const toggleCard = (index) => {
    if (dropdownOpenCard !== index) setDropdownOpenCard(index);
    else setDropdownOpenCard(false);
  };

  const toggleVersion = async (index, card) => {
    if (openVersion !== index) {
      setListLoading(true);
      setOpenVersion(index);
      let area = localStorage.getItem("area");
      let menus = JSON.parse(localStorage.getItem("menus"));
      let menuSelecionado = menus?.find(
        (item) =>
          // eslint-disable-next-line eqeqeq
          item.area == localStorage.getItem("area") &&
          // eslint-disable-next-line eqeqeq
          item.id == localStorage.getItem("idMenu")
      );

      let cardSelected =
        card.values?.length > 1
          ? card?.values[card.abaAtiva - 1]
          : card.values[0];
      let versoesName = await getVersoes(
        area,
        menuSelecionado.menu,
        cardSelected.titulo,
        cardSelected.abaTitulo
      );
      let versoes = await getVersoes(
        area,
        localStorage.getItem("idMenu"),
        cardSelected.idCard?.toString(),
        cardSelected.idAba?.toString()
      );
      versoes.push(...versoesName);
      versoes = _.sortBy(versoes, function (dateObj) {
        return moment(dateObj.name, "DD-MM-YYYY_HH:mm:ss:SS");
      }).reverse();
      setList(versoes);
      setData([...data]);
      setListLoading(false);
    } else setOpenVersion(false);
  };

  // const frame = (url, height) => {
  //   let tokenGenerator = token;
  //   console.log("entra aqui sim");
  //   if (url.includes("godash")) {
  //     tokenGenerator = tokenSystem;
  //     var params = new URLSearchParams(new URL(url).search);
  //     var dashboardId = params.get("dashboardId");
  //     var urlGod = `${URL_GODASH}${dashboardId}&godash=true&token=${tokenGenerator}`;
  //     return {
  //       __html:
  //         '<iframe src="' +
  //         urlGod +
  //         '"width="100%" height="' +
  //         (height - 28) +
  //         '"></iframe>',
  //     };
  //   }
  //   return {
  //     __html:
  //       '<iframe style="border:none;" src="' +
  //       url +
  //       tokenGenerator +
  //       '" width="100%" height="' +
  //       (height - 28) +
  //       '"></iframe>',
  //   };
  // };

  const frame = (url, height) => {
    let tokenGenerator = token; // padrão
    let finalUrl = url;

    if (url.includes("godash")) {
      // Caso  godash
      console.log("godash");
      tokenGenerator = tokenSystem;
      const params = new URLSearchParams(new URL(url).search);
      const dashboardId = params.get("dashboardId");
      finalUrl = `${URL_GODASH}${dashboardId}&godash=true&token=${tokenGenerator}`;
    } else if (
      url.startsWith("https://devlnxstorage.blob.core.windows.net/abs-storage/")
    ) {
      // Blob storage: usa token padrão, mas TEM que adicionar o token
      console.log("blob");
      finalUrl = `${url}${tokenGenerator}`;
    } else if (
      url.startsWith("https://") &&
      url.includes(".azurewebsites.net/")
    ) {
      // Azure Websites: usa tokenSystem
      console.log("azure");
      tokenGenerator = tokenSystem;
      finalUrl = `${url}?token=${tokenGenerator}`;
    } else {
      // Outros casos: usa token padrão
      finalUrl = `${url}${tokenGenerator}`;
    }

    return {
      __html: `<iframe style="border:none;" src="${finalUrl}" width="100%" height="${
        height - 28
      }"></iframe>`,
    };
  };

  const toDataURL = (url) => {
    return fetch(url)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  };

  const handleCopy = (event, aba) => {
    if (!aba.url_local)
      return autoCloseAlert(
        "Esse arquivo está sendo atualizado aguarde 1 minuto e atualize a tela"
      );
    event.preventDefault();
    navigator.clipboard.writeText(aba.url_local);
    return autoCloseAlert("Copiado");
  };

  const autoCloseAlert = (msg) => {
    toast.info(msg);
  };

  const download = async (url, token, filename, titulo) => {
    let user = JSON.parse(localStorage.getItem("user-profile"));
    let model = {
      usuario: user?.username,
      acao: `Clique para download do arquivo: ${filename}.${url
        .split(".")
        .pop()} no card: ${titulo}`,
      pagina_origem: `${props.menu} | ${props.area}`,
    };
    postAcao(model);
    const a = document.createElement("a");
    a.href = await toDataURL(url + token);
    a.download = filename + "." + url?.split(".").pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleDelete = (card) => {
    MySwal.fire({
      title: "Deletar?",
      text: `Tem certeza que gostaria de excluir a aba ${card.abaTitulo}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Deletar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-outline-primary ml-1",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
    }).then(function (result) {
      if (result.value) {
        let area = localStorage.getItem("area");
        let menus = JSON.parse(localStorage.getItem("menus"));
        let menuSelecionado = menus?.find(
          (item) =>
            // eslint-disable-next-line eqeqeq
            item.area == localStorage.getItem("area") &&
            // eslint-disable-next-line eqeqeq
            item.id == localStorage.getItem("idMenu")
        );
        let model = {
          params: {
            arg1: area,
            arg2: menuSelecionado.menu,
            arg3: card.titulo,
            arg4: card.abaTitulo,
          },
        };
        props.deleteTab(model);
      }
    });
  };

  const handleDeleteCard = (card) => {
    MySwal.fire({
      title: "Deletar?",
      text: `Tem certeza que gostaria de excluir o card ${card.titulo}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Deletar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-outline-primary ml-1",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
    }).then(function (result) {
      if (result.value) {
        let area = localStorage.getItem("area");
        let menus = JSON.parse(localStorage.getItem("menus"));
        let menuSelecionado = menus?.find(
          (item) =>
            // eslint-disable-next-line eqeqeq
            item.area == localStorage.getItem("area") &&
            // eslint-disable-next-line eqeqeq
            item.id == localStorage.getItem("idMenu")
        );
        let model = {
          params: {
            arg1: area,
            arg2: menuSelecionado.menu,
            arg3: card.titulo,
            arg4: card.abaTitulo,
          },
        };
        props.deleteCard(model);
      }
    });
  };

  const handleOrderCard = (card, from, to, isNew) => {
    var cardsToEdit = [];
    if (isNew) {
      card.isNew = true;
      data.push({
        key: card.ordem,
        values: [card],
      });
    } else {
      data.forEach((x) => {
        if (
          Number(x.values[0].ordem) === from &&
          x.values[0].idCard === card.idCard
        )
          x.values[0] = card;
      });
    }

    var ordenado = data.reduce((prev, current, idx, self) => {
      if (
        Number(prev[idx - 1]?.values[0].ordem) === to &&
        Number(prev[idx - 1]?.values[0].ordem) > from
      ) {
        prev[idx - 1].values[0].ordem =
          Number(prev[idx - 1].values[0].ordem) - 1;

        cardsToEdit.push(prev[idx - 1].values[0]);
      } else if (
        Number(prev[idx - 1]?.values[0].ordem) >= to &&
        Number(prev[idx - 1]?.values[0].ordem) < from
      ) {
        prev[idx - 1].values[0].ordem =
          Number(prev[idx - 1].values[0].ordem) + 1;

        cardsToEdit.push(prev[idx - 1].values[0]);
      } else if (
        Number(prev[idx - 1]?.values[0].ordem) === from &&
        prev[idx - 1]?.values[0].idCard === card.idCard
      ) {
        prev[idx - 1].values[0].ordem = cardsToEdit.find((x) => x.ordem === to)
          ? to + 1
          : to;

        cardsToEdit.push(prev[idx - 1].values[0]);
      } else if (
        Number(prev[idx - 1]?.values[0].ordem) < to &&
        Number(prev[idx - 1]?.values[0].ordem) > from
      ) {
        prev[idx - 1].values[0].ordem =
          Number(prev[idx - 1].values[0].ordem) - 1;

        cardsToEdit.push(prev[idx - 1].values[0]);
      }
      if (idx === data.length - 1) {
        if (Number(current.values[0].ordem) === to) {
          current.values[0].ordem = Number(current.values[0].ordem) - 1;

          cardsToEdit.push(current.values[0]);
        } else if (
          Number(current?.values[0].ordem) === from &&
          current?.values[0].idCard === card.idCard
        ) {
          current.values[0].ordem = cardsToEdit.find((x) => x.ordem === to)
            ? to + 1
            : to;

          cardsToEdit.push(current.values[0]);
        } else if (
          Number(current?.values[0].ordem) < to &&
          Number(current?.values[0].ordem) > from
        ) {
          current.values[0].ordem = Number(current.values[0].ordem) - 1;

          cardsToEdit.push(current.values[0]);
        } else if (
          Number(current?.values[0].ordem) > to &&
          Number(current?.values[0].ordem) < from
        ) {
          current.values[0].ordem = Number(current.values[0].ordem) - 1;
          current.values[0].ordem = Number(current.values[0].ordem) - 1;

          cardsToEdit.push(current.values[0]);
        }
      }

      prev.push(current);
      return prev;
    }, []);
    cardsToEdit = ordenado.map((x) => {
      return x.values[0];
    });
    saveCards(cardsToEdit);
  };

  const saveCards = (cards) => {
    let area = localStorage.getItem("area");
    let menus = JSON.parse(localStorage.getItem("menus"));
    let menuSelecionado = menus?.find(
      (item) =>
        // eslint-disable-next-line eqeqeq
        item.area == localStorage.getItem("area") &&
        // eslint-disable-next-line eqeqeq
        item.id == localStorage.getItem("idMenu")
    );
    cards.forEach((card) => {
      if (!card.isNew) {
        let model = {
          params: {
            arg1: area,
            arg2: menuSelecionado.menu,
            arg3: card.name ?? card.titulo,
            arg4: card.width ?? card.largura ?? "",
            arg5: card.height ?? card.altura ?? "",
            arg6: card.nameOld ?? card.titulo,
            arg7: card.tipoAba,
            arg8: card.ordem,
          },
        };
        props.updateCard(model);
      } else {
        let model = {
          params: {
            arg1: area,
            arg2: menuSelecionado.menu,
            arg3: card.name,
            arg4: card.width,
            arg5: card.height,
            arg6: card.tipoAba,
            arg7: card.ordem,
          },
        };
        props.createCard(model);
      }
    });
  };

  const handleOrderAba = (aba, from, to, isNew) => {
    var abasToEdit = [];
    if (isNew) {
      aba.isNew = true;
      abaEdit.push(aba);
    }
    abaEdit.map((item, index) => {
      item.ordemAba = index + 1;
      return item;
    });
    saveAbasOrder(abaEdit);
    if (!isNew) {
      let abaEd = abaEdit.find((abs) => abs.idAba === aba.idAba);
      from = abaEd.ordemAba;
    }

    let indexTo = abaEdit.findIndex((item) => item.ordemAba === to);
    let indexFrom = abaEdit.findIndex((item) => item.ordemAba === from);
    if (indexTo === -1) {
      aba.ordemAba = to;
      aba.ordemAbaNew = to;
      abasToEdit.push(aba);
    } else {
      for (var i = 0; i < abaEdit.length; i++) {
        if (i >= indexTo && i < indexFrom && abaEdit[i].idAba !== aba.idAba) {
          abaEdit[i].ordemAba = abaEdit[i].ordemAba + 1;
          abaEdit[i].ordemAbaNew = abaEdit[i].ordemAba;
          abasToEdit.push(abaEdit[i]);
        }
        if (i > indexFrom && i <= indexTo && abaEdit[i].idAba !== aba.idAba) {
          abaEdit[i].ordemAba = abaEdit[i].ordemAba - 1;
          abaEdit[i].ordemAbaNew = abaEdit[i].ordemAba;
          abasToEdit.push(abaEdit[i]);
        }
        //  if(i === abaEdit.length - 1 &&  abaEdit[i].idAba !== aba.idAba){
        //   abaEdit[i].ordemAba =  abaEdit[i].ordemAba - 1;
        //   abaEdit[i].ordemAbaNew =  abaEdit[i].ordemAba;
        //   abasToEdit.push( abaEdit[i]);
        //  }
      }
      aba.ordemAba = to;
      aba.ordemAbaNew = to;
      abasToEdit.push(aba);
    }

    saveAbas(abasToEdit);
  };

  const saveAbasOrder = (abas) => {
    let area = localStorage.getItem("area");
    let menus = JSON.parse(localStorage.getItem("menus"));
    let menuSelecionado = menus?.find(
      (item) =>
        // eslint-disable-next-line eqeqeq
        item.area == localStorage.getItem("area") &&
        // eslint-disable-next-line eqeqeq
        item.id == localStorage.getItem("idMenu")
    );
    abas.forEach((aba) => {
      let model = {
        params: {
          arg1: area,
          arg2: menuSelecionado.menu,
          arg3: card.titulo,
          arg4: aba.name ?? aba.abaTitulo,
          arg5: aba.nameOld ?? aba.abaTitulo,
          arg6: aba.ordemAbaNew ?? aba.ordemAba,
        },
      };
      props.updateTab(model);
    });
  };

  const saveAbas = (abas) => {
    let area = localStorage.getItem("area");
    let menus = JSON.parse(localStorage.getItem("menus"));
    let menuSelecionado = menus?.find(
      (item) =>
        // eslint-disable-next-line eqeqeq
        item.area == localStorage.getItem("area") &&
        // eslint-disable-next-line eqeqeq
        item.id == localStorage.getItem("idMenu")
    );
    abas.forEach((aba) => {
      if (!aba.isNew) {
        let model = {
          params: {
            arg1: area,
            arg2: menuSelecionado.menu,
            arg3: card.titulo,
            arg4: aba.name ?? aba.abaTitulo,
            arg5: aba.nameOld ?? aba.abaTitulo,
            arg6: aba.ordemAbaNew ?? aba.ordemAba,
          },
        };
        props.updateTab(model);
      } else {
        let model = {
          params: {
            arg1: area,
            arg2: menuSelecionado.menu,
            arg3: card.titulo,
            arg4: aba.name ?? aba.abaTitulo,
            arg5: aba.ordemAbaNew ?? aba.ordemAba,
          },
        };
        props.createTab(model);
      }
    });
  };

  const Check = ({ card, version }) => {
    if (card.values.length > 1)
      if (card.values[card.abaAtiva - 1]?.url?.includes(version.name))
        return (
          <i
            title="Versão ativa"
            style={{ marginLeft: 10, fontSize: 15 }}
            className="nc-icon nc-check-2"
          />
        );
    if (card.values[0]?.url?.includes(version.name))
      return (
        <i
          title="Versão ativa"
          style={{ marginLeft: 10, fontSize: 15 }}
          className="nc-icon nc-check-2"
        />
      );
    return null;
  };

  const handleIsGodash = (item) => {
    let abaAtiva =
      item.values.length > 1
        ? item?.values[item.abaAtiva - 1]
        : item?.values[0];
    return abaAtiva?.url?.includes("godash");
  };

  const downloadUrl = async (pdfUrl) => {
    const response = await fetch(pdfUrl);
    let buffer = await response.arrayBuffer();
    const file = new Blob([buffer], { type: "application/pdf" });
    return URL.createObjectURL(file);
  };

  const handleDownloadPdf = async (event, aba) => {
    const a = document.createElement("a");
    let url = new URL(aba.url);
    const parsed = queryString.parse(url.search);
    a.href = await downloadUrl(URL_PDF + parsed.dashboardId + ".pdf" + token);
    a.download = aba.abaTitulo;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <React.Fragment>
      {event ? (
        <Events />
      ) : (
        <div>
          <ToastContainer
            position="top-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          {/* Same as */}
          <CadastroAba
            open={openAba}
            setOpen={setOpenAba}
            card={card}
            createTab={props.createTab}
            updateAba={updateAba}
            updateTab={props.updateTab}
            handleOrderAba={handleOrderAba}
            maxSize={card?.maxSize}
          />
          <PublicarAba
            open={openPublicaAba}
            setOpen={setOpenPublicaAba}
            card={card}
            publishTab={props.publishTab}
          />
          <CadastroCard
            open={openCard}
            setOpen={setOpenCard}
            createCard={props.createCard}
            handleOrderCard={handleOrderCard}
            maxSize={data.length}
          />
          <EditarCard
            open={openEditCard}
            setOpen={setOpenEditCard}
            updateCard={props.updateCard}
            handleOrderCard={handleOrderCard}
            maxSize={data.length}
            cardSelected={card}
            update={updateCard}
          />
          <CadastrarMenu
            open={openCadastraMenu}
            setOpen={setOpenCadastraMenu}
            nameDefault={true}
          />
          <VerImg card={card} open={openImg} setOpen={setOpenImg} />
          <Row className="card-rows">
            {props.loading ? (
              <div
                style={{
                  height: "69vh",
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ReactLoading
                  type="spin"
                  color="#2682ff"
                  height={"40px"}
                  width={"50px"}
                />
              </div>
            ) : props.hasData ? (
              <Fragment>
                {data.map((item, index) => (
                  <Col
                    key={index}
                    lg={item?.values[0].largura}
                    md={12}
                    className="card-cols"
                  >
                    <Card className="frame">
                      <CardHeader className="header-card">
                        <Row>
                          <Col xs="9" lg="5">
                            <CardTitle tag="h5" className="card-title">
                              {item.values[0].titulo}
                            </CardTitle>
                          </Col>
                          <Col xs="3" lg="7">
                            {hasAcess && !isMobile ? (
                              <div xs="12" lg="6" style={{ marginTop: -11 }}>
                                <ButtonDropdown
                                  style={{ float: "right" }}
                                  color="default"
                                  isOpen={index === dropdownOpenCard}
                                  toggle={() => toggleCard(index)}
                                >
                                  <DropdownToggle color="default" caret>
                                    Editar Card
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem
                                      onClick={(e) => {
                                        setOpenCard(!openCard);
                                        setUpdateCard(false);
                                      }}
                                    >
                                      Criar
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem
                                      onClick={(e) => {
                                        setOpenEditCard(!openEditCard);
                                        setCard(
                                          item.values.length > 1
                                            ? item?.values[item.abaAtiva - 1]
                                            : item?.values[0]
                                        );
                                        setUpdateCard(true);
                                      }}
                                    >
                                      Editar
                                    </DropdownItem>
                                    <DropdownItem divider />

                                    <DropdownItem
                                      onClick={(e) => {
                                        setCard(
                                          item.values.length > 1
                                            ? item?.values[item.abaAtiva - 1]
                                            : item?.values[0]
                                        );
                                        handleDeleteCard(
                                          item.values.length > 1
                                            ? item?.values[item.abaAtiva - 1]
                                            : item?.values[0]
                                        );
                                      }}
                                    >
                                      Deletar
                                    </DropdownItem>
                                    <DropdownItem divider />
                                  </DropdownMenu>
                                </ButtonDropdown>

                                <ButtonDropdown
                                  style={{ float: "right" }}
                                  color="default"
                                  isOpen={index === dropdownOpenAba}
                                  toggle={() => toggleAba(index)}
                                >
                                  <DropdownToggle color="default" caret>
                                    Editar Aba
                                  </DropdownToggle>
                                  <DropdownMenu>
                                    <DropdownItem
                                      onClick={(e) => {
                                        setOpenPublicaAba(!openPublicaAba);
                                        setCard(
                                          item.values.length > 1
                                            ? item?.values[item.abaAtiva - 1]
                                            : item?.values[0]
                                        );
                                      }}
                                    >
                                      Publicar
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem
                                      onClick={(e) => {
                                        setOpenAba(!openAba);
                                        let card =
                                          item.values.length > 1
                                            ? item?.values[item.abaAtiva - 1]
                                            : item?.values[0];
                                        card.maxSize = item.values.length;
                                        setCard(card);
                                        setAbaEdit(item.values);
                                        setUpdateAba(false);
                                      }}
                                    >
                                      Criar
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem
                                      onClick={(e) => {
                                        setOpenAba(!openAba);
                                        let card =
                                          item.values.length > 1
                                            ? item?.values[item.abaAtiva - 1]
                                            : item?.values[0];
                                        card.maxSize = item.values.length;
                                        setCard(card);
                                        setAbaEdit(item.values);
                                        setUpdateAba(true);
                                      }}
                                    >
                                      Editar
                                    </DropdownItem>
                                    <DropdownItem divider />

                                    <DropdownItem
                                      onClick={(e) => {
                                        setCard(
                                          item.values.length > 1
                                            ? item?.values[item.abaAtiva - 1]
                                            : item?.values[0]
                                        );
                                        handleDelete(
                                          item.values.length > 1
                                            ? item?.values[item.abaAtiva - 1]
                                            : item?.values[0]
                                        );
                                      }}
                                    >
                                      Deletar
                                    </DropdownItem>
                                    <DropdownItem divider />
                                  </DropdownMenu>
                                </ButtonDropdown>
                              </div>
                            ) : null}
                            <>
                              {
                                item.values[0].tipo_arquivo !==
                                  "transcription" && (
                                  <ButtonDropdown
                                    style={{ float: "right" }}
                                    color="default"
                                    isOpen={index === openVersion}
                                    toggle={() => toggleVersion(index, item)}
                                  >
                                    <DropdownToggle
                                      className="version"
                                      color="default"
                                      caret
                                    >
                                      Versões
                                    </DropdownToggle>
                                    <DropdownMenu
                                      style={{
                                        left: "-23px",
                                        position: "absolute",
                                        top: "0px",
                                      }}
                                    >
                                      {listLoading ? (
                                        <div style={{ marginLeft: "2.5rem" }}>
                                          <ReactLoading
                                            type="spin"
                                            color="#2682ff"
                                            height={"30px"}
                                            width={"20px"}
                                            //
                                          />
                                        </div>
                                      ) : (
                                        <Fragment>
                                          {list.map((version) => (
                                            <DropdownItem
                                              onClick={(e) => {
                                                setCard(
                                                  item.values.length > 1
                                                    ? item?.values[
                                                        item.abaAtiva - 1
                                                      ]
                                                    : item?.values[0]
                                                );
                                                let abaAtiva =
                                                  item.values.length > 1
                                                    ? item?.values[
                                                        item.abaAtiva - 1
                                                      ]
                                                    : item?.values[0];
                                                abaAtiva.url = version.url;
                                                abaAtiva.isUrlDefault =
                                                  version.url ===
                                                  abaAtiva.urlDefault;
                                                setData([...data]);
                                              }}
                                            >
                                              {version.name}
                                              <Check
                                                card={item}
                                                version={version}
                                              />
                                            </DropdownItem>
                                          ))}
                                        </Fragment>
                                      )}
                                    </DropdownMenu>
                                  </ButtonDropdown>
                                )}
                            </>
                            {enableLocalFile && !isMobile ? (
                              // <FormGroup className="">
                              <Button
                                outline
                                style={{
                                  float: "right",
                                  height: "19px",
                                  //padding: "5px 5px",
                                  //paddingTop: 1,
                                }}
                                color="default"
                                //className="btn-round"
                                onClick={(e) => {
                                  let abaAtiva =
                                    item.values.length > 1
                                      ? item?.values[item.abaAtiva - 1]
                                      : item?.values[0];
                                  handleCopy(e, abaAtiva);
                                }}
                              >
                                <span></span>
                                Copiar diretório
                              </Button>
                            ) : // </FormGroup>
                            null}
                            {handleIsGodash(item) && !isMobile ? (
                              <FormGroup className="">
                                <Button
                                  outline
                                  style={{
                                    float: "right",
                                    height: "19px",
                                    //padding: "5px 5px",
                                    //paddingTop: 1,
                                  }}
                                  color="default"
                                  //className="btn-round"
                                  onClick={(e) => {
                                    let abaAtiva =
                                      item.values.length > 1
                                        ? item?.values[item.abaAtiva - 1]
                                        : item?.values[0];
                                    handleDownloadPdf(e, abaAtiva);
                                  }}
                                >
                                  {/* <i
                                style={{ fontSize: 15, marginRight: 6, top: 3 }}
                                className="nc-icon nc-single-copy-04"
                              /> */}
                                  <span></span>
                                  Download PDF
                                </Button>
                              </FormGroup>
                            ) : null}

                            {item?.values[item.abaAtiva - 1]?.tipo_arquivo ===
                              "img" &&
                              !isMobile && (
                                <span
                                  style={{
                                    marginRight: 10,
                                    cursor: "pointer",
                                    float: "right",
                                    paddingTop: 12,
                                  }}
                                  title="Baixar imagem"
                                  onClick={() =>
                                    download(
                                      item?.values[item.abaAtiva - 1].url,
                                      token,
                                      item?.values[item.abaAtiva - 1].abaTitulo,
                                      "image/png"
                                    )
                                  }
                                >
                                  {" "}
                                  <i className="fa fa-download" />
                                </span>
                              )}
                            {/* {hasAcess && !isMobile ? (
                        <FormGroup>
                          <Label
                            style={{
                              float: "right",
                              margin: 5,
                              marginRight: 15,
                            }}
                          >
                            <Input
                              style={{
                                marginTop: 3,
                                fontSize: "12px",
                                fontWeight: "bold",
                              }}
                              type="checkbox"
                              checked={
                                item.values.length > 1
                                  ? item?.values[item.abaAtiva - 1]
                                      .habilita_arquivo_local
                                  : item?.values[0].habilita_arquivo_local
                              }
                              onChange={(e) => {
                                let abaAtiva =
                                  item.values.length > 1
                                    ? item?.values[item.abaAtiva - 1]
                                    : item?.values[0];
                                props.enableLocalFileTab({
                                  params: {
                                    arg1: abaAtiva.idAba,
                                    arg2: !abaAtiva.habilita_arquivo_local,
                                  },
                                });
                              }}
                            />

                            <span
                              style={{ fontSize: "12px", fontWeight: "bold" }}
                            >
                              Salvar em storage local{" "}
                            </span>
                          </Label>
                        </FormGroup>
                      ) : null} */}
                          </Col>
                        </Row>
                      </CardHeader>
                      <CardBody style={{ height: item.altura }}>
                        <div>
                          {item.values.length > 1 ? (
                            item.values[0].tipoAba && !isMobile ? (
                              <Nav tabs>
                                {item.values.map((aba, index3) => (
                                  <NavItem>
                                    <NavLink
                                      className={classnames(
                                        {
                                          active: item.abaAtiva === index3 + 1,
                                        },
                                        "tabs"
                                      )}
                                      onClick={() => {
                                        toggle(item, index3 + 1);
                                      }}
                                    >
                                      {aba.abaTitulo}
                                    </NavLink>
                                  </NavItem>
                                ))}
                              </Nav>
                            ) : (
                              <Select
                                // placeholder={<div>{item.values[0].abaTitulo}</div>}
                                classNamePrefix="react-select"
                                isSearchable={isMobile ? false : true}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    fontSize: 10,
                                    height: 28,
                                    minHeight: 28,
                                  }),
                                }}
                                onChange={(e) => toggle(item, e.value + 1)}
                                options={item.values.map((item1, index3) => {
                                  return {
                                    label: item1.abaTitulo,
                                    value: index3,
                                  };
                                })}
                              />
                            )
                          ) : (
                            <Row>
                              <Col sm="12">
                                {item.values[0].tipo_arquivo === "img" ? (
                                  <div
                                    style={{ textAlign: "center" }}
                                    onClick={() => {
                                      setCard(item.values[0]);
                                      setOpenImg(true);
                                    }}
                                  >
                                    <img
                                      style={{ pointerEvents: "none" }}
                                      alt={item.values[0].nomeAba}
                                      src={item.values[0].url + token}
                                      onClick={() => setOpenImg(true)}
                                    ></img>
                                  </div>
                                ) : item.values[0].tipo_arquivo === "html" ? (
                                  <div
                                    dangerouslySetInnerHTML={frame(
                                      item.values[0].url,
                                      item.values[0].altura - 28
                                    )}
                                  />
                                ) : item.values[0].tipo_arquivo ===
                                  "download" ? (
                                  //&& item.values[0].url.split(".").pop() !== "pdf"
                                  <div>
                                    {/* {item.values[0].url.split(".").pop()} */}
                                    <span
                                      className="download-text"
                                      style={{
                                        cursor: "pointer",
                                        color: "#2682FF",
                                        fontSize: 13,
                                      }}
                                      onClick={() =>
                                        download(
                                          item.values[0].url,
                                          token,
                                          item.values[0].abaTitulo,
                                          item.values[0].titulo
                                        )
                                      }
                                    >
                                      {item.values[0].isUrlDefault ? (
                                        <Fragment>
                                          Download{" "}
                                          {item.values[0].nome_arquivo
                                            ? item.values[0].nome_arquivo
                                            : item.values[0].abaTitulo +
                                              "." +
                                              item.values[0].url
                                                .split(".")
                                                .pop()}
                                        </Fragment>
                                      ) : (
                                        <span> Download</span>
                                      )}
                                    </span>
                                  </div>
                                ) : //item.values[0].tipo_arquivo === "download" &&
                                //   item.values[0].url.split(".").pop() === "pdf" ? (
                                //   <div
                                //     style={{ height: item.values[0].altura + "px" }}
                                //     className="report-style-class"
                                //   >
                                //     <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
                                //       <Viewer
                                //         fileUrl={item.values[0].url + token}
                                //         plugins={[defaultLayoutPluginInstance]}
                                //       />
                                //     </Worker>
                                //   </div>
                                // ) :
                                item.values[0].tipo_arquivo ===
                                  "transcription" ? (
                                  <LiveTranscriptPage2 fileNameCurrent={item.values[0].nome_arquivo} />
                                ) : null}
                                <div
                                  style={{
                                    margin: "5px 0px 0px",
                                    fontSize: 10,
                                  }}
                                >
                                  {item.values[0].Descricao}
                                </div>
                              </Col>
                            </Row>
                          )}
                        </div>
                        <div>
                          {item.values.length > 1 ? (
                            <TabContent activeTab={item.abaAtiva}>
                              {item.values.map((aba, index2) => (
                                <TabPane tabId={index2 + 1} key={index2}>
                                  <Row>
                                    <Col sm="12">
                                      {aba.tipo_arquivo === "img" ? (
                                        <div
                                          style={{ textAlign: "center" }}
                                          onClick={() => {
                                            setCard(aba);
                                            setOpenImg(true);
                                          }}
                                        >
                                          <img
                                            style={{ pointerEvents: "none" }}
                                            alt={aba.title}
                                            src={aba.url + token}
                                          />
                                        </div>
                                      ) : aba.tipo_arquivo === "html" &&
                                        item.abaAtiva === index2 + 1 ? (
                                        <div
                                          dangerouslySetInnerHTML={frame(
                                            aba.url,
                                            aba.altura
                                          )}
                                        />
                                      ) : aba.tipo_arquivo === "download" ? (
                                        <div style={{ margin: "20px" }}>
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              color: "#51cbce",
                                            }}
                                            onClick={() =>
                                              download(
                                                aba.url,
                                                token,
                                                aba.abaTitulo,
                                                aba.titulo
                                              )
                                            }
                                          >
                                            Download {aba.abaTitulo}.
                                            {aba.url.split(".").pop()}
                                          </span>
                                        </div>
                                      ) : null}

                                      <div
                                        style={{
                                          margin: "5px 0px 0px",
                                          fontSize: 10,
                                        }}
                                      >
                                        {aba.Descricao}
                                      </div>
                                    </Col>
                                  </Row>
                                </TabPane>
                              ))}
                            </TabContent>
                          ) : null}
                        </div>
                      </CardBody>
                      <CardFooter>
                        <hr style={{ margin: "5px" }} />
                        <div
                          className="stats"
                          style={{ marginBottom: "5px", fontSize: 10 }}
                        >
                          <i className="fa fa-history" />{" "}
                          <span>
                            {moment(
                              item.values.length > 1
                                ? item?.values[item.abaAtiva - 1].dt_created
                                : item?.values[0].dt_created
                            ).fromNow()}{" "}
                            {"  |  "}
                          </span>
                          {moment(
                            item.values.length > 1
                              ? item?.values[item.abaAtiva - 1].dt_created
                              : item?.values[0].dt_created
                          ).format("llll")}
                        </div>
                      </CardFooter>
                    </Card>
                  </Col>
                ))}
              </Fragment>
            ) : (
              <Fragment>
                <div>
                  <Col xs="12" style={{ marginTop: -11 }}>
                    {localStorage.getItem("idMenu") && hasAcess ? (
                      <Button
                        color="default"
                        onClick={(e) => {
                          setOpenCard(!openCard);
                          setUpdateCard(false);
                        }}
                      >
                        {" "}
                        Criar Card
                      </Button>
                    ) : !localStorage.getItem("idMenu") &&
                      hasAcess &&
                      !window.location.href?.includes("dashboard") ? (
                      <Button
                        color="default"
                        onClick={(e) => {
                          setOpenCadastraMenu(!openCadastraMenu);
                        }}
                      >
                        {" "}
                        Criar Menu
                      </Button>
                    ) : null}
                  </Col>
                </div>
                <div
                  style={{
                    justifyContent: "center",
                    height: "74vh",
                    display: "flex",
                    alignItems: "center",
                    color: "green",
                    width: "100%",
                  }}
                >
                  <div>Nenhum relatório cadastrado para esse menu!</div>
                </div>
              </Fragment>
            )}
          </Row>
        </div>
      )}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    publish: state.screening.screening.publish,
    create: state.screening.screening.create,
    //e/rror: state.screening.screening.error,
    //loading: state.screening.screening.loading,
  };
};

export default connect(mapStateToProps, {
  createTab,
  publishTab,
  updateTab,
  deleteTab,
  createCard,
  updateCard,
  deleteCard,
  enableLocalFileTab,
})(Frame);
